import React, {Component} from 'react';
import PropTypes from "prop-types";
import Button from "reactstrap/es/Button";
import transactionsClient from "../../client/transactionsClient"
import {Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Label, Input} from "reactstrap";

class TransactionVoidDialog extends Component {
    state = {
        comment: ""
    };

    async voidTransaction(){
        transactionsClient.transactions.voidTransaction({idOrRef: this.props.transaction.ref, comment: this.state.comment})
            .then(r => console.log("Transaction voided"))
            .catch(e => console.log(e))
            .finally(r => this.props.toggle())
    }

    render() {
        const {transaction, toggle, onVoid, className} = this.props;

        return <Modal isOpen={true} toggle={toggle} className={className}>
            <ModalHeader toggle={toggle}>Void Transaction {transaction.ref} - {transaction.type.name}</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="exampleText">Void Comment</Label>
                    <Input type="textarea" name="text" id="voidComment" value={this.state.comment} onChange={e => this.setState({comment: e.target.value})} />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button disabled={this.state.comment.length === 0} color="primary" onClick={() => this.voidTransaction()}>Void Transaction</Button>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    }
}

TransactionVoidDialog.propTypes = {
    transaction: PropTypes.object.isRequired,
    onVoid: PropTypes.func,
    toggle: PropTypes.func.isRequired,
    className: PropTypes.string
};

export {TransactionVoidDialog};
